"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvidenceLocatorFactsSchema = exports.EvidenceBoundingBoxSourceSchema = exports.EvidenceBoundingBoxSource = exports.EvidenceBoundingBoxSchema = void 0;
const z = require("zod");
const evidence_vote_types_1 = require("./evidence-vote.types");
exports.EvidenceBoundingBoxSchema = z.object({
    ulx: z.number(),
    uly: z.number(),
    lrx: z.number(),
    lry: z.number(),
});
var EvidenceBoundingBoxSource;
(function (EvidenceBoundingBoxSource) {
    EvidenceBoundingBoxSource["Ocr"] = "ocr";
    EvidenceBoundingBoxSource["OcrTextMatch"] = "ocr_text_match";
    EvidenceBoundingBoxSource["BboxGapFill"] = "bbox_gap_fill";
    EvidenceBoundingBoxSource["Unplaced"] = "unplaced";
})(EvidenceBoundingBoxSource || (exports.EvidenceBoundingBoxSource = EvidenceBoundingBoxSource = {}));
exports.EvidenceBoundingBoxSourceSchema = z.nativeEnum(EvidenceBoundingBoxSource);
exports.EvidenceLocatorFactsSchema = z.object({
    address: z.string(),
    fileId: z.string(),
    kind: evidence_vote_types_1.EvidenceLocatorKindSchema,
    provider: z.string().nullable(),
    pageStart: z.number().int().min(1).nullable(),
    pageEnd: z.number().int().min(1).nullable(),
    bbox: exports.EvidenceBoundingBoxSchema.nullable(),
    bboxSource: exports.EvidenceBoundingBoxSourceSchema.nullable(),
    elementType: z.string().nullable(),
    text: z.string().nullable(),
    markdown: z.string().nullable(),
});
//# sourceMappingURL=evidence-locator.types.js.map